// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2CXBo","bigColWidth":"Table_bigColWidth__3nu-Q","biggerColWidth":"Table_biggerColWidth__1rDIr","row":"Table_row__1vvIj","col":"Table_col__24M46"};